import {
  flow,
  isObject,
  isString,
  map,
  matches,
  pick,
  startsWith,
  uniqWith,
} from 'lodash';

/**
 * Key fields that distinguish one color form another
 */
export interface ILegacyColorId {
  colorFamily: string;
  subColorDescription: string;
  mainColorCode?: string;
}

/**
 * Fields provided by fox pro to describe color. Implemented by:
 * * {@link ProductSkuModel}
 * * {@link SalesOrderProductSkuModel}
 * * {@link PackingListProductSkuModel}
 */
export interface ILegacyColor extends ILegacyColorId {
  // TODO restore, when fields in ILegacyColorId changes
  // colorFamily?: string;
  // subColorDescription?: string;

  colorCode?: string;
  colorDescription?: string;
  colorFamilySupplier?: string;
  colorSupplier?: string;
  mainColorCode?: string;
  mainColorDescription?: string;
  subColorCode?: string;
}

/**
 * Returns label for provided color
 *
 * Note! WiP pattern - stand alone method, to be used in stand alone classes or angular.
 * @param {ILegacyColorId} color to be presented
 * @return {string} label
 */
export function getColorLabel(color: ILegacyColorId): string {
  if (!isObject(color)) {
    return '';
  }

  const output = [];

  if (isString(color.colorFamily) && !startsWith(color.colorFamily, '**')) {
    output.push(color.colorFamily);
  }

  if (
    isString(color.subColorDescription) &&
    !startsWith(color.subColorDescription, '**')
  ) {
    output.push(color.subColorDescription);
  }

  if (isString(color.mainColorCode) && !startsWith(color.mainColorCode, '**')) {
    output.push(color.mainColorCode);
  }

  return output.join(' ');
}

/**
 * Returns all unique colors that were found on the list
 *
 * Note! WiP pattern - stand alone method, to be used in stand alone classes or angular.
 * @param {ILegacyColorId[]} colors array of colors
 * @return {ILegacyColorId[]}
 * unique colors that were found
 */
export function getUniqueColors(colors: ILegacyColorId[]): ILegacyColorId[] {
  return flow([
    (x) =>
      map(x, (sku) =>
        pick(sku, ['colorFamily', 'subColorDescription', 'mainColorCode']),
      ),
    (x) => uniqWith(x, (a, b) => matches(a)(b)),
  ])(colors);
}
